import { nxConfirmPopup, nxAlertPopup } from "../etc/nxConfirm.js";

export class ninegrid {


	constructor() {
		console.log(`welcome nine-grid@${ninegrid.version}`, window.location.hostname);
		//console.log(i18next);
	}

	static extendElementPrototype() {
        if (!("isHidden" in Element.prototype)) { // ✅ 이미 존재하는 경우 중복 정의 방지
            Object.defineProperty(Element.prototype, "isHidden", {
                get: function () {
                    const style = window.getComputedStyle(this);
					//console.log(this, style.display, style.visibility, style.opacity);
                    return style.display === "none" || style.visibility === "hidden" || style.opacity === "0";
                }
            });
        }

		if (!("shadow" in Element.prototype)) {
			Object.defineProperty(Element.prototype, "shadow", {
				get: function () {
					let currentElement = this;
                    return {
						closest: function (selector) {
							//let currentElement = self;

							while (currentElement) {

								if (currentElement.matches(selector)) return currentElement;

								// ✅ Shadow Root 내부에서 `selector`를 찾음
								if (currentElement.shadowRoot) {
									//const found = currentElement.shadowRoot.querySelector(selector);
									//if (found) return found;
								}

								// ✅ Shadow Root를 넘어가 부모 요소 탐색
								currentElement = currentElement.getRootNode()?.host || currentElement.parentElement || null;
							}
							return null;
						},
						querySelectorAll: (selector) => {
							let elements = [];

							if (currentElement instanceof NodeList) {
								currentElement.forEach(ctx => {
									if (selector instanceof NodeList) {
										selector.forEach(sel => {
										elements.push(...ctx.querySelectorAll(sel));
										});
									} else if (selector instanceof HTMLElement) {
										elements.push(...ctx.querySelectorAll(selector));
									} else {
										elements.push(...ctx.querySelectorAll(selector));
									}
								});
							} else {
								if (selector instanceof HTMLElement) {
									elements = [selector];
								} else if (selector instanceof NodeList) {
									selector.forEach(sel => {
										elements.push(...currentElement.querySelectorAll(sel));
									});
								} else {
									elements = currentElement.querySelectorAll(selector);
								}
							}

							return elements;
						},
					};
                }
			});
		}
    }

	static LOG = {
			LEVEL : {
				ALL		: 0,
				DEBUG	: 1,
				INFO	: 2,
				WARN	: 3,
				ERROR	: 4,
				OFF		: 9,
			},
		};
	
	static EVENT = {
		LOAD				: "load",
		BUTTON_CLICK		: "buttonclick",
		LINK_CLICK			: "linklick",
		LAYOUT_CHANGED		: "layoutchanged",
		CELL_CLICK			: "cellclick",
		CELL_DBL_CLICK		: "celldblclick",
		HEADCELL_CLICK		: "headcellclick",
		HEADCELL_DBL_CLICK	: "headcelldblclick",
		FOOTCELL_CLICK		: "footcellclick",
		FOOTCELL_DBL_CLICK	: "footcelldblclick",
		CELL_POS_CHANGED	: "cellposchanged",
		ROW_POS_CHANGED		: "rowposchanged",
		DATA_CHANGED		: "datachanged",
		CAN_ROW_MOVE		: "canrowmove",
		ROW_MOVED			: "rowmoved",
		//CAN_FIXED_CHANGE	: "canfixedchange",
		//FIXED_CHANGED		: "fixedchanged",
		TAB_LOAD			: "tabload",
	};

	static BAND = {
		BODY	: "body",
		LEFT	: "left",
		RIGHT	: "right",
	};

	/** .__ng._[ninegrid.ROW.ID] */
	static ROW = {
		ID			: 0,
		INDEX		: 1,		/** 전체 INDEX */
		ORDER		: 2,		/** valid(collapse,pin,paging) ROW */
		VISIBLE_ROW	: 3,		/** visible INDEX */
		STATE		: 4,
		FILTER		: 5,
		PIN			: 6,
		EXPAND		: 7,
		COLLAPSE	: 8,
		VISIBLE		: 9,
		PAGING		: 10,
		DELETED		: 11,
		HEIGHT		: 12,
		ORIGIN_ORDER: 13,
		ORIGIN_VALUE: 14,
		EXPAND_CHECK: 15,
	}

	static ROW_STATE = {
		EMPTY	: 0,
		NORMAL	: 1,
		INSERT	: 2,
		UPDATE	: 4,
		DELETE	: 8,
		GROUP	: 16,
	}

	static SELECTTYPE = {
		NONE	: "none",
		ROW		: "row",
		ROWS	: "rows",
		COL		: "col",
		COLS	: "cols",
		CELL	: "cell",
		AREA	: "area",
	}

	static COLINDICATORTYPE = {
		EXPAND	: "expand",
		COLLAPSE: "collapse",
	}

	static PAGINGTYPE = {
		NONE	: "none",
		CLIENT	: "client",
		SERVER	: "server",
	}

	static PAGINGCOUNT = {
		AUTO		: "auto",
		NUM_1		: "1",
		NUM_5		: "5",
		NUM_10		: "10",
		NUM_20		: "20",
		NUM_30		: "30",
		NUM_50		: "50",
		NUM_100		: "100",
		NUM_1000	: "1000",
		NUM_10000	: "10000",
	}

    static version = "6.1429.0";

    static options = {
		confirm : {
			"class"			: "classic",
			"animation"		: "run",	//run,moveUp
			"true-text"		: "Yes",
			"false-text"	: "No",
		},
		alert : {
			"class"			: "classic",
			"animation"		: "zoom",	//run, reverseRun, moveUp, moveDown, zoom, fade
		},
	};

	static cssPath = null;
	
	
	static openFileDialog = (v) => {
		
		return new Promise((resolve, reject) => {
	        // 기존 input 요소 제거
	        const existingInput = document.getElementById("ninegridFileInput");
	        if (existingInput) {
	            existingInput.remove();
	        }

	        // 새로운 파일 입력 엘리먼트 생성
	        const input = document.createElement("input");
	        input.type = "file";
	        input.accept = "*";  
	        input.id = "ninegridFileInput";

	        input.addEventListener("change", (event) => {
	            const file = event.target.files[0];
	            if (file) {
	                resolve(file); // 파일 선택 시 Promise 해결
	            } else {
	                reject(new Error("파일이 선택되지 않았습니다."));
	            }
	        });

	        input.click(); // 파일 선택 창 열기
	    });
	}
	
	static getCustomPath = (c,v) => {

		if (nine.cssPath) {
			return `@import "${nine.cssPath}/ninegrid/${v}"`;
		}

		let cssPath;
		let host;
		if (c.tagName == "NINE-GRID") {
			host = c;
		}
		else {
			host = c.getRootNode().host;
			if (host && host.tagName != "NINE-GRID") host = host.getRootNode().host;
		}

		if (host && host.tagName == "NINE-GRID") {
			cssPath = host.getAttribute("css-path");
		}
		
		//console.log("========================", ninegrid.cssPath);

		if (!cssPath) cssPath = ninegrid.cssPath;
		//console.log("================");
		//console.log(cssPath);
		
		//console.log(cssPath ? `@import "${cssPath}/dist/${v}";` : null);

		//console.log("========================", cssPath ? `@import "${cssPath}/${v}";` : "");

		return cssPath ? `@import "${cssPath}/${v}";` : "";
	};
	
	static closest = (selector, element) => {
		let currentElement = element;

		while (currentElement) {
			if (currentElement.tagName.toLowerCase() === selector) {
				return currentElement;
			}
		
			currentElement = currentElement.getRootNode().host;
		}

		return null;
	}
	
	static waitForInnerHTML = (element, maxAttempts = 3, intervalTime = 100) => {
		return new Promise((resolve, reject) => {
			let attempts = 0;
			const interval = setInterval(() => {
				if (element.innerHTML.trim() !== "") {
					//console.log("InnerHTML 확인됨, init() 실행 가능!");
					clearInterval(interval);
					resolve();
				} else {
					attempts++;
					//console.log(`InnerHTML이 비어 있음, ${attempts}/${maxAttempts}번 재시도`);
	
					if (attempts >= maxAttempts) {
						clearInterval(interval);
						reject("InnerHTML을 확인하지 못했습니다.");
					}
				}
			}, intervalTime);
		});
	};

	static delayQuerySelector = (selector, root = document, maxAttempts = 3, intervalTime = 100) => {
		return new Promise((resolve, reject) => {
			let attempts = 0;
			const interval = setInterval(() => {
				const el = ninegrid.querySelector(selector, root);

				if (el) {
					//console.log("InnerHTML 확인됨, init() 실행 가능!");
					clearInterval(interval);
					resolve(el);
				} else {
					attempts++;
					//console.log(`InnerHTML이 비어 있음, ${attempts}/${maxAttempts}번 재시도`);

					if (attempts >= maxAttempts) {
						clearInterval(interval);
						reject("Element를 찾지 못했습니다.");
					}
				}
			}, intervalTime);
		});
	};
	
	static copyProperty = (target, source, properties) => {
		
		if (!Array.isArray(properties)) properties = [properties];
		
		for (var v in source) {
			if (properties.includes(v)) {
				target[v] = source[v];
			}
		}
	};

	static decode = (...args) => {
		const key = args[0];

		for (let i = 1; i < args.length - 1; i += 2) {
			if (args[i] === key) return args[i + 1];
		}

		// fallback 처리 (짝이 맞지 않을 경우)
		return args.length % 2 === 0 ? args[args.length - 1] : null;
	};



	static isMobile = () => {
		return /(iPhone|iPad|Android|BlackBerry|Windows Phone)/i.test(navigator.userAgent);
	};

	static randomUUID = (num) => {
		if (!num) num = 10;
		
		const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
		let result = '';
		const charactersLength = characters.length;
		for (let i = 0; i < num; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}

		return result;
	};

	static isNvl = (v) => {
		return (v === null || v === undefined || v === '') ? true : false;
	};
	static isNull = (v) => {
		return ninegrid.isNvl(v);
	};
	static nvl = (v, v2) => {
		return ninegrid.isNvl(v) ? v2 : v;
	};

	static isEllipsis = (element) => {
		const computedStyle = window.getComputedStyle(element);
 
		const clone = element.cloneNode(true);
		clone.style.fontFamily = computedStyle.fontFamily;
		clone.style.fontSize = computedStyle.fontSize;
		clone.style.lineHeight = computedStyle.lineHeight;
		clone.style.width = computedStyle.width;  // 원본 너비 유지
		//clone.style.visibility = "hidden";
		document.body.appendChild(clone);

		console.log(clone, element);
		console.log(clone.scrollWidth, element.clientWidth, clone.scrollHeight, element.clientHeight);

		const isTruncated = clone.scrollWidth > element.clientWidth || clone.scrollHeight > element.clientHeight;
		//document.body.removeChild(clone);

		return isTruncated;
	}
	
	static oppositeColor = (bgColor, lightColor, darkColor) => {
		var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
		var r = parseInt(color.substring(0, 2), 16); // hexToR
		var g = parseInt(color.substring(2, 4), 16); // hexToG
		var b = parseInt(color.substring(4, 6), 16); // hexToB
		var uicolors = [r / 255, g / 255, b / 255];
		var c = uicolors.map((col) => {
			if (col <= 0.03928) {
				return col / 12.92;
			}
			
			return Math.pow((col + 0.055) / 1.055, 2.4);
		});
		var L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
		return (L > 0.179) ? darkColor : lightColor;
	};

	static parseDate = (v) => {
		var date;
		
		if (/[^0-9]/.test(v)) {
			date = new Date(v);
		}
		
		return date;
	};
	static parseDate1 = (_date,_format,_delimiter) => {
		var formatLowerCase=_format.toLowerCase();
		var formatItems=formatLowerCase.split(_delimiter);
		var dateItems=_date.split(_delimiter);
		var monthIndex=formatItems.indexOf("mm");
		var dayIndex=formatItems.indexOf("dd");
		var yearIndex=formatItems.indexOf("yyyy");
		var month=parseInt(dateItems[monthIndex]);
		month-=1;
		var formatedDate = new Date(dateItems[yearIndex],month,dateItems[dayIndex]);
		return formatedDate;
	};

	static goto = (selector, params) => {

		const el = document.querySelector(selector);
		console.log(el);
		console.log(selector);

		if (!el) return;

		document.querySelectorAll(".list-wrapper.active,[class*='detail-wrapper-'].active").forEach((el) => {
			el.classList.remove("active");
		});

		el.classList.add("active");

		return el;
	};


	static context;
	static measureTextSize = (_text, _font) => {
		if (typeof _text === 'number') _text = _text + "";
		
		if (!_text) return {width:null,height:null};
		
		_text = _text.replaceAll("\n", "<br>")

		// Set the font
		if (!ninegrid.context) {
			const canvas = document.createElement('canvas');
			ninegrid.context = canvas.getContext('2d');
		}
		ninegrid.context.font = _font;

		// Measure the text
		var w = 0;
		var h = 0;
		for (var v of _text.split("<br>")) {
			v = v.replace(/<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/ig, "");
			const metrics = ninegrid.context.measureText(v);
			w = Math.max(w, metrics.width);
			
			//let fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
			//let actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;

			h += metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
		}

		// Return the width in pixels
		return {
			width	: w,
			height	: h
		};
	};

	static num2ExcelCol = (num) => {
		const alpCount = 'Z'.charCodeAt(0) - 'A'.charCodeAt(0) + 1;
		let result = '';
		
		while (num !== -1) {
			result = String.fromCharCode('A'.charCodeAt(0) + (num % alpCount)) + result;
			num = Math.floor(num / alpCount) - 1;
		}
		
		return result;
	};
	
	static move = (arr, from, to) => {
		arr.splice(to, 0, arr.splice(from, 1)[0]);
	};


	static binarySearchValue = (arr, searchProperty, searchValue, targetProperty, separator) => {
		if (!Array.isArray(searchValue)) searchValue = [searchValue];
		
		var r = [];
		for (var v of searchValue) {
			var idx = arr.map(m => { return m[searchProperty]; }).nineBinarySearch(v);
			r.push( (idx < 0) ? v : arr[idx][targetProperty] );
		}
		
		return r.join(separator || ",");
	};
		
	static removeIf = (arr,callback) => {
		var i = 0;
		while (i < arr.length) {
			if (callback(arr[i], i)) {
				return arr.splice(i, 1);
			}
			else {
				++i;
			}
		}
	};

	static sum = (arr,prop) => {
		return arr.map(m => { return m[prop]; }).reduce((a, b) => (a+b));
	};

	static avg = (arr,prop) => {
		//console.log(arr, prop);
		if (arr.length == 0) return 0;
		
		if (prop) arr = arr.getMap(prop);
		//console.log(arr);
		//if (prop) return (arr.map(m => { return m[v]; }).reduce((a,b) => (a+b)) / arr.length);
		
		return (arr.reduce((a, b) => (a+b)) / arr.length);
		//return (arr.map(m => { return m[v]; }).reduce((a, b) => (a+b)) / arr.length);
	};

	static lpad = (v,n,str) => {
		return Array(n - String(v).length + 1).join(str || '0') + v;
	};

	static rpad = (v,n,str) => {
		return v + Array(n - String(v).length + 1).join(str || '0');
	};

	static cut = (v,len) => {
		var str = v;
		var s = 0;
		for (var i=0; i<str.length; i++) {
			s += (str.charCodeAt(i) > 128) ? 2 : 1;
			if (s > len) return str.substring(0,i);
		}
		return str;
	};
	static getByteLength = (v) => {
		return v.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g,"$&$1$2").length;
	};

	static formatDate = (v, _format) => {
		return ninegrid.toDate(v, _format);
	};

	static toDate = (v, format) => {
		var today = new Date();
		//20000101 yyyymmdd
		var yIndex = format.indexOf('yyyy');
		var mIndex = format.indexOf('mm');
		var dIndex = format.indexOf('dd');
		var hIndex = format.indexOf('hh');
		var iIndex = format.indexOf('mi');
		var sIndex = format.indexOf('ss');
		
		var year	= (yIndex > -1) ? v.substr(yIndex, 4) : today.getFullYear();
		var month	= (mIndex > -1) ? v.substr(mIndex, 2)-1 : today.getMonth()-1;
		var day		= (dIndex > -1) ? v.substr(dIndex, 2) : today.getDate();
		var hour	= (hIndex > -1) ? v.substr(hIndex, 2) : today.getHours();
		var minute	= (iIndex > -1) ? v.substr(iIndex, 2) : today.getMinutes();
		var second	= (sIndex > -1) ? v.substr(sIndex, 2) : today.getSeconds();
		
		return new Date(year,month,day,hour,minute,second);
	};

	static formatString = (v, format, locale) => {
		if (isNaN(v)) return "";
		
		locale = locale || "en-US";
		format = format.toLowerCase();
		
		return format
				.replace("yyyy", v.getFullYear())
				.replace("yy", v.getYear())
				.replace("mon", v.toLocaleString(locale, { month: "short" }))
				.replace("mm", ninegrid.lpad(v.getMonth()+1, 2))
				.replace("dd", ninegrid.lpad(v.getDate(), 2))
				.replace("hh", ninegrid.lpad(v.getHours(), 2))
				.replace("mi", ninegrid.lpad(v.getMinutes(), 2))
				.replace("ss", ninegrid.lpad(v.getSeconds(), 2));
	};
	
	
	static log = {
		level : window.location.hostname == "localhost" ? ninegrid.LOG.LEVEL.DEBUG : ninegrid.LOG.LEVEL.WARN,
		//level : LOG.LEVEL.WARN,
	}
	static debug	= (...args) => { if (ninegrid.log.level <= ninegrid.LOG.LEVEL.DEBUG) { console.trace(...args); } };
	static info		= (...args) => { if (ninegrid.log.level <= ninegrid.LOG.LEVEL.INFO) { console.trace(...args); } };
	static warn		= (...args) => { if (ninegrid.log.level <= ninegrid.LOG.LEVEL.WARN) { console.warn(...args); } };
	static error	= (...args) => { if (ninegrid.log.level <= ninegrid.LOG.LEVEL.ERROR) { console.error(...args); } };

	static global = {
		locale : (navigator.language || navigator.userLanguage || 'en').toLowerCase().substring(0, 2),
		lang : navigator.language,
	}


	/**
	static querySelectorAll = (selector, root) => {
		
		root = root || document;
		
		const results = Array.from(root.querySelectorAll(selector));
		const pushNestedResults = function (root) {
			ninegrid.querySelectorAll(selector, root).forEach(elem => {
				if (!results.includes(elem)) {
					results.push(elem);
				}
			});
		};
		
		if (root.shadowRoot) {
			pushNestedResults(root.shadowRoot);
		}
		
		for (const elem of root.querySelectorAll('*')) {
			if (elem.shadowRoot) {
				pushNestedResults(elem.shadowRoot);
			}
		}
		
		return results;
	};
	*/

	static querySelectorAll(selector, root = document) {
		const results = [];

		const search = (node) => {
			// 현재 노드에서 찾기
			node.querySelectorAll?.(selector)?.forEach(elem => {
				if (!results.includes(elem)) results.push(elem);
			});

			// 모든 자식 요소 순회
			node.querySelectorAll?.('*')?.forEach(child => {
				if (child.shadowRoot) {
					search(child.shadowRoot); // 💡 재귀적으로 계속 들어가!
				}
			});
		};

		// 시작점
		search(root.shadowRoot ?? root);

		return results;
	}

	static querySelector(selector, root = document) {
		let found = root.querySelector?.(selector);
		if (found) return found;

		// 최상위 shadow root가 있다면 먼저 탐색
		if (root.shadowRoot) {
			found = this.querySelector(selector, root.shadowRoot);
			if (found) return found;
		}

		// 모든 자식 요소 탐색
		for (const elem of root.querySelectorAll?.('*') ?? []) {
			if (elem.shadowRoot) {
				found = this.querySelector(selector, elem.shadowRoot);
				if (found) return found;
			}
		}

		return null; // 없으면 null 반환
	};

	static setOptions = (k,o) => {
		for (const prop in o) {
			if (ninegrid.options[k][prop]) {
				ninegrid.options[k][prop] = o[prop];
			}
		}
	};

	static confirm(message, title, options) {
		return nxConfirmPopup.confirm(message, title, options);
	};

	static alert(message, title, options) {
		return nxAlertPopup.alert(message, title, options);
	};

	static loading = {
		show: () => {
			let overlay = document.getElementById("global-loading-overlay");
			if (!overlay) {
					overlay = document.createElement("div");
					overlay.id = "global-loading-overlay";
					overlay.className = "loading-overlay";

					overlay.style.position = "fixed";
					overlay.style.inset = "0";
					overlay.style.zIndex = "9999";
					overlay.style.background = "rgba(0, 0, 0, 0.4)";
					overlay.style.color = "white";
					overlay.style.display = "flex";
					overlay.style.justifyContent = "center";
					overlay.style.alignItems = "center";
					overlay.style.fontSize = "20px";
					overlay.style.pointerEvents = "all";
					overlay.style.backdropFilter = "blur(2px)";
					overlay.innerHTML = `
			<div style="text-align: center;">
			  <div class="loading-spinner"></div>
			</div>
		  `;

			document.body.appendChild(overlay);

			// CSS 스피너 스타일 삽입
			const style = document.createElement("style");
			style.innerHTML = `
				.loading-spinner {
				  width: 48px;
				  height: 48px;
				  border: 5px solid rgba(255, 255, 255, 0.3);
				  border-top-color: white;
				  border-radius: 50%;
				  animation: spin 1s linear infinite;
				}
		
				@keyframes spin {
				  to { transform: rotate(360deg); }
				}
			  `;

				document.head.appendChild(style);
			}

			overlay.style.display = "flex";
		},
		hide: () => {
			const overlay = document.getElementById("global-loading-overlay");
			if (overlay) overlay.style.display = "none";
		},
	};


	static i18n = {
		convertArrayToJSON : (arr) => {
			let result = {};
			
			for (const str of arr) {
				
				if (!str) continue;
				
				const index = str.indexOf("=");
				if (index <= 0) continue;
				
				const keys = str.substring(0, index).split('.');
				const value = str.substring(index+1);
				let current = result;
				
				for (let i = 0; i < keys.length; i++) {
					if (i === keys.length - 1) {
						current[keys[i]] = value;
					}
					else {
						if (!current[keys[i]]) {
							current[keys[i]] = {};
						}
						current = current[keys[i]];
					}
				}
			}
		
			return result;
		},
		updateContent : () => {
			ninegrid.querySelectorAll("nx-i18n,nx-span").forEach(v => {
				if (v.refresh) v.refresh();
			});
			ninegrid.querySelectorAll("nine-grid").forEach(v => {
				if (v.refresh) v.refreshData();
			});
		},
		addResourceBundle : (args) => {
			//console.log(args);
			
			let count = Math.floor(args.length / 2);
			
			for (var i=0; i < args.length; i+=2) {
				//console.log(i, args.length);
				if (i+1 >= args.length) break;
				
				const locale = args[i];
				const fileNm = args[i+1];
				
				$.ajax({
					url: fileNm,	// "/properties/message.ko.prop",
					dataType: "text",
					success: (text) => {
						i18next.addResourceBundle(locale, 'translation', ninegrid.i18n.convertArrayToJSON(text.split("\n")));
						
						/**
						 * 마지막 파일인 경우 화면갱신
						 */
						if (--count == 0) i18next.changeLanguage(ninegrid.global.locale);
					}
				});
			}
			
			//console.log("=========")
			//ninegrid.i18n.updateContent();
		},
		init : () => {
			//console.log(ninegrid.global.locale);
			i18next.init(
				{
					lng: ninegrid.global.locale,//isKorean ? "ko" : "en", // 한국어인지, 영어인지 표시
					debug: window.location.hostname == "localhost" ? true : false,
					resources: {},
				},
				function(err, t) {
					if (err) {
						console.error(err);
					} else { // 에러가 없을 경우 설정한 언어로 json 안의 텍스트들 대입
						//ninegrid.i18n.updateContent();
					}
				}
			);
			
			// 언어 변환 시 이벤트 (위의 select에서 onchange="i18next.changeLanguage(this.value)" 이벤트)
			i18next.on("languageChanged", () => {
				ninegrid.i18n.updateContent(); // 바뀐 언어에 따라 웹페이지 텍스트 재대입
			});
		},
		t : (v) => {
			console.log(i18next);
			return i18next.t(v);
		},
	}

	static alert = (message, title, options) => {
		return nxAlertPopup.alert(message, title, options);
	}
	

	/**
	 * Qdrant 필터링 조건에 따라 JSON 배열을 필터링하는 함수입니다.
	 *
	 * @param {Array<Object>} jsonArray 필터링할 JSON 객체 배열입니다.
	 * @param {Object} filter 필터링 조건 객체입니다. Qdrant 필터와 유사한 구조를 가집니다.
	 * 예시:
	 * {
	 * must: [ // 모든 조건이 참이어야 함
	 * { key: "field1", match: { value: "some_value" } },
	 * { key: "field2", range: { gte: 10, lt: 20 } }
	 * ],
	 * should: [ // 하나 이상의 조건이 참이어야 함
	 * { key: "field3", match: { value: "another_value" } },
	 * { key: "field4", match: { any: ["valueA", "valueB"] } }
	 * ],
	 * must_not: [ // 어떤 조건도 참이 아니어야 함
	 * { key: "field5", match: { value: "excluded_value" } }
	 * ]
	 * }
	 * @returns {Array<Object>} 필터링된 JSON 객체 배열입니다.
	 */
	static filter = (jsonArray, filter) => {
		/**
		 * 단일 필터링 조건을 평가하는 헬퍼 함수입니다.
		 * @param {Object} item 현재 평가 중인 JSON 객체입니다.
		 * @param {Object} condition 평가할 단일 조건입니다. (예: { key: "field1", match: { value: "some_value" } })
		 * @returns {boolean} 조건이 참이면 true, 그렇지 않으면 false.
		 */
		const evaluateCondition = (item, condition) => {
			const valueInItem = item[condition.key];

			if (condition.match) {
				const match = condition.match;
				if (match.value !== undefined) {
					return valueInItem === match.value;
				}
				if (match.any && Array.isArray(match.any)) {
					return match.any.includes(valueInItem);
				}
				if (match.all && Array.isArray(match.all)) {
					// item[condition.key]가 배열이라고 가정
					if (!Array.isArray(valueInItem)) return false;
					return match.all.every(val => valueInItem.includes(val));
				}
				if (match.text !== undefined) {
					// 텍스트 매치는 부분 문자열 일치 또는 정규식 등으로 확장 가능
					// 여기서는 단순 포함 여부로 구현
					return typeof valueInItem === 'string' && valueInItem.includes(match.text);
				}
			}

			/**
			if (condition.range) {
				const range = condition.range;
				//console.log(valueInItem, range, typeof valueInItem, typeof range.gte);
				if (typeof valueInItem === "string") {
					if (range.gte !== undefined && valueInItem < range.gte) return false;
					if (range.gt !== undefined && valueInItem <= range.gt) return false;
					if (range.lte !== undefined && valueInItem > range.lte) return false;
					if (range.lt !== undefined && valueInItem >= range.lt) return false;
					return true;
				}
				else if (typeof valueInItem !== 'number') {
					return false; // 숫자가 아니면 범위 비교 불가
				}

				if (range.gte !== undefined && !(valueInItem >= range.gte)) return false;
				if (range.gt !== undefined && !(valueInItem > range.gt)) return false;
				if (range.lte !== undefined && !(valueInItem <= range.lte)) return false;
				if (range.lt !== undefined && !(valueInItem < range.lt)) return false;
				return true;
			} */
			if (condition.range) {
				const range = condition.range;

				if (typeof valueInItem === "string" && typeof range.gte === "string") {
					if (range.gte !== undefined && valueInItem < range.gte) return false;
					if (range.gt !== undefined && valueInItem <= range.gt) return false;
					if (range.lte !== undefined && valueInItem > range.lte) return false;
					if (range.lt !== undefined && valueInItem >= range.lt) return false;
					return true;
				} else if (typeof valueInItem === "number") {
					if (range.gte !== undefined && valueInItem < range.gte) return false;
					if (range.gt !== undefined && valueInItem <= range.gt) return false;
					if (range.lte !== undefined && valueInItem > range.lte) return false;
					if (range.lt !== undefined && valueInItem >= range.lt) return false;
					return true;
				} else {
					return false; // 문자열도 숫자도 아닌 경우
				}
			}


			// 다른 필터 타입 (예: `geo_bounding_box`, `has_id` 등)은 필요에 따라 추가 구현
			// 현재는 `match`와 `range`만 지원합니다.

			return false; // 지원하지 않는 조건 타입
		}
		if (!jsonArray || !Array.isArray(jsonArray)) {
			console.error("첫 번째 인수는 JSON 배열이어야 합니다.");
			return [];
		}
		if (!filter || typeof filter !== 'object') {
			// 필터 조건이 없거나 유효하지 않으면 원본 배열 반환
			return jsonArray;
		}

		return jsonArray.filter(item => {
			// 'must' 조건 처리: 모든 'must' 조건이 참이어야 합니다.
			if (filter.must && !filter.must.every(condition => evaluateCondition(item, condition))) {
				return false;
			}

			// 'should' 조건 처리: 하나 이상의 'should' 조건이 참이어야 합니다.
			// 'should' 조건이 없으면 이 부분은 건너뜁니다.
			if (filter.should && filter.should.length > 0 && !filter.should.some(condition => evaluateCondition(item, condition))) {
				return false;
			} else if (filter.should && filter.should.length === 0 && (filter.must || filter.must_not)) {
				// 'should'가 비어있고 'must'나 'must_not'가 있으면 'should'는 필터링에 영향 없음.
				// 하지만 'should'만 있고 비어있다면, 사실상 필터링이 안 되는 것과 같으므로 true 반환.
				// 이 로직은 Qdrant의 'should'가 비어있을 때의 동작과 일치하도록 조정될 수 있습니다.
				// 현재는 'should'가 비어있으면 필터링에 영향이 없도록 합니다.
			}


			// 'must_not' 조건 처리: 어떤 'must_not' 조건도 참이 아니어야 합니다.
			if (filter.must_not && filter.must_not.some(condition => evaluateCondition(item, condition))) {
				return false;
			}

			return true;
		});
	}

	



	  static j = {
		copyEvents: (source, target) => {
			const events = getEventListeners(source);
			for (const [type, listeners] of Object.entries(events)) {
				listeners.forEach(listener => {
					target.addEventListener(type, listener.listener, listener.options);
				});
			}
		},
	    querySelectorAll: (selector, context = document) => {
	      let elements = [];

	      if (context instanceof NodeList) {
	        context.forEach(ctx => {
	          if (selector instanceof NodeList) {
	            selector.forEach(sel => {
	              elements.push(...ctx.querySelectorAll(sel));
	            });
	          } else if (selector instanceof HTMLElement) {
	            elements.push(...ctx.querySelectorAll(selector));
	          } else {
	            elements.push(...ctx.querySelectorAll(selector));
	          }
	        });
	      } else {
	        if (selector instanceof HTMLElement) {
	          elements = [selector];
	        } else if (selector instanceof NodeList) {
	          selector.forEach(sel => {
	            elements.push(...context.querySelectorAll(sel));
	          });
	        } else {
	          elements = context.querySelectorAll(selector);
	        }
	      }

	      return {
	        elements,
	        elem() {
	          return elements[0];
	        },
			clone(withEvents = false) {
				const clones = [];
				elements.forEach(element => {
					const clone = element.cloneNode(true);
					if (withEvents) {
						ninegrid.j.copyEvents(element, clone);
					}
					clones.push(clone);
				});
				this.elements = clones;
				return this;
			},
			children() {
				let childrenArray = [];
				elements.forEach(element => {
					childrenArray.push(...element.children);
				});
				this.elements = childrenArray;
				return this;
			},
	        attr(attribute, value) {
				if (value === undefined) {
					return elements[0] ? elements[0].getAttribute(attribute) : null;
				}
				else {
					elements.forEach(element => {
						//element.setAttribute(attribute, value);
						//element.setAttribute(attribute, value === true ? "true" : value);
						if (value === false) {
							element.removeAttribute(attribute);
						}
						else {
							element.setAttribute(attribute, value === true ? "true" : value);
						}
					});
					return this;
				}
	        },
			removeAttr(...attributes) {
			    attributes.forEach(attribute => {
			        elements.forEach(element => {
			            element.removeAttribute(attribute);
			        });
			    });
			    return this;
			},
	        css(property, value) {
	          elements.forEach(element => {
	            element.style[property] = value;
	          });
	          return this;
	        },
			hasClass(className) {
				const elementsArray = Array.isArray(elements) ? elements : Array.from(elements);
				
				return elementsArray.some(element => element.classList.contains(className));
			},
	        addClass(className) {
	          elements.forEach(element => {
	            element.classList.add(className);
	          });
	          return this;
	        },
	        removeClass(className) {
	          elements.forEach(element => {
	            element.classList.remove(className);
	          });
	          return this;
	        },
			show() {
				elements.forEach(element => {
		          element.style.display = '';
				  if (getComputedStyle(element).display === 'none') {
						element.style.display = 'block';
					}
				});
	          return this;
	        },
	        hide() {
	          elements.forEach(element => {
	            element.style.display = 'none';
	          });
	          return this;
	        },
	      };
	    }
	  };



	static x = {
		querySelectorAll :
			(selector, context = document) => {
				let elements = (selector instanceof HTMLElement) ? [selector] : context.querySelectorAll(selector);
				
				//console.log(context, selector);
				//const elements = context.querySelectorAll(selector);
				return {
					elements,
					elem: function() {
						return elements[0];
					},
					attr: function(attribute, value) {
						if (value === undefined) {
							return elements[0] ? elements[0].getAttribute(attribute) : null;
						}
						else {
							elements.forEach(element => {
								//element.setAttribute(attribute, value);
								//element.setAttribute(attribute, value === true ? "true" : value);
								if (value === false) {
									element.removeAttribute(attribute);
								}
								else {
									element.setAttribute(attribute, value === true ? "true" : value);
								}
							});
							return this;
						}
					},
					css: function(property, value) {
						elements.forEach(element => {
							element.style[property] = value;
						});
						return this;
					},
					addClass: function(className) {
						elements.forEach(element => {
							if (!element.classList.contains(className)) {
								element.classList.add(className);
							}
						});
						return this;
					},
					removeClass: function(className) {
						elements.forEach(element => {
							if (element.classList.contains(className)) {
								element.classList.remove(className);
							}
						});
						return this;
					},
				}
			},
	}
}

Array.prototype.nineBinarySearch = function(target)
{
	//this.sort((a,b) => { return a > b ? 1 : -1; });
	
	let start = 0;
	let end = this.length-1
	let mid
	
	while (start <= end) { //점점 좁혀지다가 start와 end의 순서가 어긋나게 되면 반복을 종료한다
	
		mid = parseInt((start+end)/2)
		
		if (target == this[mid]) {
			return mid;
		}
		else{
			if (target < this[mid]){
				end = mid - 1;
			}
			else {
				start = mid + 1;
			}
		}
	}
	
	return -1;
};